
import { defineComponent, reactive, inject, watch, ref } from "vue";
import { Field, ErrorMessage } from "vee-validate";
import { numberFormatter } from "@/utils/index";

export default defineComponent({
  name: "investment-ticket-size",
  components: {
    Field,
    ErrorMessage,
  },
  props: {
    fromUpdateInvestor:{
      type: Boolean,
      required: false
    },
    formDataTemp: {
      type: Object,
      required: true,
    },
  },
  setup(props, { emit }) {
    const formData = ref<Record<string, unknown>>(props.formDataTemp);
    const formatter = numberFormatter;
    const investorProfile = inject("investorProfile");
    const currencyCode = ref<string | unknown>("");
    const minInvestment = ref<string | unknown>("");
    const maxInvestment = ref<string | unknown>("");
    const formatInput = (e) => {
      if (!e.target.value) {
        minInvestment.value = ""
        maxInvestment.value = ""
        return;
      }
      if (e.target.name == "minInvestment")
        minInvestment.value = formatter(
          parseFloat(e.target.value.replace(/,/g, "")).toString(),
          "en-US"
        );
      else if (e.target.name == "maxInvestment")
        maxInvestment.value = formatter(
          parseFloat(e.target.value.replace(/,/g, "")).toString(),
          "en-US"
        );
    };
    const stageOfEvolution = reactive([
      { name: "stageOfEvolutionPreSeed", value: false },
      { name: "stageOfEvolutionSeed", value: false },
      { name: "stageOfEvolutionPreSeriesA", value: false },
      { name: "stageOfEvolutionSeriesA", value: false },
    ]);
    const minimumTraction = reactive([
      { name: "minimumTractionPreMvp", value: false },
      { name: "minimumTractionPostMvp", value: false },
      { name: "minimumTractionPreRevenue", value: false },
      { name: "minimumTractionPostRevenue", value: false },
    ]);
    const geoFocus = reactive([
      { name: "geoFocusUk", value: false },
      { name: "geoFocusEu", value: false },
      { name: "geoFocusUs", value: false },
      { name: "geoFocusGlobal", value: false },
    ]);
    const taxReliefStatus = reactive([
      { name: "taxReliefStatusSeis", value: false },
      { name: "taxReliefStatusEis", value: false },
      { name: "taxReliefStatusNa", value: false },
    ]);
    watch(
      () => props.formDataTemp,
      () => {
        formData.value = props.formDataTemp;
      }
    );
    watch(investorProfile as Record<string, unknown>, (value) => {
      fetchData(value);
    });
    const fetchData = (value) => {
      currencyCode.value = value.currencyCode;
      minInvestment.value = formatter(value.minInvestment, "en-US");
      maxInvestment.value = formatter(value.maxInvestment, "en-US");
      for (let i = 0; i < stageOfEvolution.length; i++) {
        if (value[stageOfEvolution[i].name] == 1)
          stageOfEvolution[i].value = true;
      }
      for (let i = 0; i < minimumTraction.length; i++) {
        if (value[minimumTraction[i].name] == 1)
          minimumTraction[i].value = true;
      }
      for (let i = 0; i < geoFocus.length; i++) {
        if (value[geoFocus[i].name] == 1) geoFocus[i].value = true;
      }
      for (let i = 0; i < taxReliefStatus.length; i++) {
        if (value[taxReliefStatus[i].name] == 1)
          taxReliefStatus[i].value = true;
      }
    };
    if ((investorProfile as Record<string, unknown>)?.value) {
      fetchData((investorProfile as Record<string, unknown>)?.value);
    }
    const fieldChanged = (event) => {
      if (event.target.type == "checkbox")
        formData.value[event.target.name] = event.target.checked ? 1 : 0;
      else if (
        event.target.name == "minInvestment" ||
        event.target.name == "maxInvestment"
      ) {
        formData.value[event.target.name] = event.target.value.replace(
          /,/g,
          ""
        );
      } else formData.value[event.target.name] = event.target.value;
      emit("form-data", formData.value);
    };
    const enums = reactive({
      stageOfEvolutionPreSeed: "Pre-seed",
      stageOfEvolutionSeed: "Seed",
      stageOfEvolutionPreSeriesA: "Pre-series A",
      stageOfEvolutionSeriesA: "Series A",
      minimumTractionPreMvp: "Pre-MVP",
      minimumTractionPostMvp: "Post-MVP",
      minimumTractionPreRevenue: "Pre-Revenue",
      minimumTractionPostRevenue: "Post-Revenue",
      geoFocusUk: "UK",
      geoFocusUs: "US",
      geoFocusEu: "EU",
      geoFocusGlobal: "Global",
      taxReliefStatusSeis: "SEIS",
      taxReliefStatusEis: "EIS",
      taxReliefStatusNa: "NA",
    });
    return {
      formatInput,
      formData,
      fieldChanged,
      stageOfEvolution,
      enums,
      minimumTraction,
      geoFocus,
      taxReliefStatus,
      currencyCode,
      minInvestment,
      maxInvestment,
    };
  },
});
